module.exports = {"unknownError":"Something went wrong","close":"Close","price":"Price"}